module.exports = __webpack_public_path__ + "img/icon_youxuanhong.4a663857.svg";